import React, { useEffect, useState } from "react";
import "./ClubMembershipCard.css";
import useAdminDataStore, { selectCurrentGroupData } from "../../../store/adminData/adminData";
import { toast } from "react-toastify";
import { saveMembershipCard } from "../../../services/firebaseService/endPoints/clubAdmin/membership";
import {
  ChantButton,
  DescriptionText,
  ScreenHeader,
} from "../../../CommonComponents";
import ImageUploadButton from "../../admin/website/ImageUploaderButton";

const ClubMembershipCard = () => {
  const groupData = useAdminDataStore(selectCurrentGroupData);

  const [imageFiles, setImageFiles] = useState({
    membershipCard: null,
  });

  const [loading, setLoading] = useState(false);

  const handleImageChange = (file, fieldName) => {
    if (fieldName === "membershipCard") {
      setImageFiles({
        ...imageFiles,
        membershipCard: file,
      });
    }
  };

  useEffect(() => {
    if (groupData?.id) {
      setImageFiles({
        membershipCard: groupData?.membershipCard || null,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupData?.id]);

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const membershipCardUrl = await saveMembershipCard(
        imageFiles.membershipCard,
        groupData?.id
      );
      if (membershipCardUrl) {
        setImageFiles({
          ...imageFiles,
          membershipCard: membershipCardUrl,
        });
      }

      toast.success("Membership card updated successfully");
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="membership-card-container">
      <ScreenHeader title="Member Card" />
      <div className="membership-card-description">
        <DescriptionText>
          Chant offers a digital membership card so your group no longer needs
          to spend money printing physical cards. Alert your partners to accept
          the card for any discounts the group has negotiated.
        </DescriptionText>
      </div>
      <div className="membership-card-content">
        <div
          style={{ marginTop: "16px" }}
          className="membership-card-custom-background mt-6"
        >
          <h5 style={{ fontSize: "18px", fontWeight: "bold" }}>
            Upload custom card
          </h5>
          <p className="pb-2">
            Card displayed as uploaded. No member/group details overlaid.
          </p>

          <ImageUploadButton
            images={
              imageFiles.membershipCard ? [imageFiles.membershipCard] : []
            }
            onSave={(images) => handleImageChange(images[0], "membershipCard")}
            aspectRatio={16 / 9}
          />
        </div>

        <div
          style={{
            marginTop: "16px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <ChantButton
            disabled={loading}
            loading={loading}
            onClick={handleSubmit}
          >
            Submit
          </ChantButton>
        </div>
      </div>
    </div>
  );
};

export default ClubMembershipCard;
